import { render, staticRenderFns } from "./swipperItensProdutos.vue?vue&type=template&id=cfcd2612&"
import script from "./swipperItensProdutos.vue?vue&type=script&lang=js&"
export * from "./swipperItensProdutos.vue?vue&type=script&lang=js&"
import style0 from "./swipperItensProdutos.vue?vue&type=style&index=0&id=cfcd2612&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports